import DgPageHeader from './src/main.vue'
// 为组件提供 install 安装方法，供按需引入
DgPageHeader.install = function (Vue) {
  Vue.component(DgPageHeader.name, DgPageHeader)
}
export default DgPageHeader

export { DgPageHeader }